import type { FunctionComponent, PropsWithChildren } from 'react';

import styles from './LabelsPopoverHeader.less';

export const LabelsPopoverHeader: FunctionComponent<
  PropsWithChildren<unknown>
> = ({ children }) => <h3 className={styles.header}>{children}</h3>;
